import React from "react";
import SearchBox from "../SearchBox/SearchBox";
import IngredientList from "../IngredientsList/IngredientsList";
import { FormControl, Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledCard = styled(Card)(({ theme }) => ({
  width: "min(520px, 80vw)",
  borderRadius: 24,
  overflow: "hidden",
  border: "1px solid rgba(255,255,255,0.12)",
  background:
    "linear-gradient(145deg, rgba(20,20,20,0.92), rgba(10,10,10,0.92))",
  boxShadow: "0 18px 55px rgba(0,0,0,0.45)",
  position: "relative",
}));

const HeroImageWrap = styled("div")({
  position: "relative",
  borderRadius: 18,
  overflow: "hidden",
});

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
  objectFit: "cover",
  display: "block",
  transform: "scale(1.02)",
});

const ImageOverlay = styled("div")({
  position: "absolute",
  inset: 0,
  background:
    "linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.18) 60%, rgba(0,0,0,0) 100%)",
  pointerEvents: "none",
});

const ChipRow = styled("div")({
  position: "absolute",
  left: 14,
  right: 14,
  bottom: 12,
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
});

const MiniChip = styled("span")({
  fontSize: 12,
  padding: "6px 10px",
  borderRadius: 999,
  background: "rgba(255,255,255,0.12)",
  border: "1px solid rgba(255,255,255,0.12)",
  backdropFilter: "blur(10px)",
  color: "rgba(255,255,255,0.92)",
});

const SearchForm = () => {
  return (
    <Grid
      container
      justifyContent="center"
      sx={{ mt: 3, px: 2 }}
      data-testid="search-form-component"
    >
      <Grid item xs={12} display="flex" justifyContent="center">
        <StyledCard elevation={0}>
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <FormControl fullWidth>
              {/* Header */}
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="overline"
                  sx={{
                    letterSpacing: 2,
                    color: "rgba(255,255,255,0.65)",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  Find something tasty
                </Typography>

                <Typography
                  variant="h4"
                  component="h3"
                  align="center"
                  sx={{
                    fontWeight: 900,
                    letterSpacing: 0.3,
                    color: "white",
                    lineHeight: 1.1,
                  }}
                >
                  Recipe Search
                </Typography>

                <Typography
                  variant="body2"
                  align="center"
                  sx={{
                    mt: 1,
                    color: "rgba(255,255,255,0.72)",
                  }}
                >
                  Choose ingredients, search, and open a recipe card for details.
                </Typography>
              </Box>

              {/* Hero image */}
              <HeroImageWrap>
                <StyledImage
                  src="https://dawn-unit-97b0.sdrowvieli1.workers.dev/recipe_search/images/ingredients.webp"
                  alt="ingredients"
                  loading="lazy"
                />
                <ImageOverlay />

                <ChipRow>
                  <MiniChip>Fast</MiniChip>
                  <MiniChip>Simple</MiniChip>
                  <MiniChip>Delicious</MiniChip>
                </ChipRow>
              </HeroImageWrap>

              {/* Content */}
              <Box sx={{ mt: 2.5 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "rgba(255,255,255,0.80)",
                    fontWeight: 800,
                    mb: 1,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                  }}
                >
                  Ingredients
                </Typography>

                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 18,
                    // background: "rgba(255,255,255,0.06)",
                    // border: "1px solid rgba(255,255,255,0.10)",
                    // boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
                    mb: 2,
                  }}
                >
                  <IngredientList />
                </Box>

                <Typography
                  variant="subtitle2"
                  sx={{
                    color: "rgba(255,255,255,0.80)",
                    fontWeight: 800,
                    mb: 1,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                  }}
                >
                  Search
                </Typography>

                <Box
                  sx={{
                    p: 1.5,
                    borderRadius: 18,
                  }}
                >
                  <SearchBox />
                </Box>
              </Box>

              {/* Tiny footer accent */}
              <Box
                sx={{
                  mt: 2.5,
                  height: 3,
                  width: "100%",
                  borderRadius: 999,
                  background:
                    "linear-gradient(90deg, rgba(255,183,77,0) 0%, rgba(255,183,77,0.95) 50%, rgba(255,183,77,0) 100%)",
                  opacity: 0.9,
                }}
              />
            </FormControl>
          </CardContent>
        </StyledCard>
      </Grid>
    </Grid>
  );
};

export default SearchForm;

